<template>
  <section style="width: 1200px; margin: auto">
    <div class="myNavMenu clearfix" @click="helpTrue = false">
      <div class="logoBox lt" @click="logoClick"></div>
      <div class="logoBox_input lt">
        <div class="input">
          <el-input
            :placeholder="$t('请输入内容')"
            v-model="input3"
            class="input-with-select"
            @keyup.enter.native="handleSearch"
          >
            <!-- <el-button slot="append" icon="el-icon-search" @click.stop="handleSearch"></el-button> -->
            <img
              slot="append"
              src="@/imgs/search.png"
              @click.stop="handleSearch"
              style="width: 20px; height: 20px; margin-right: 0; cursor: pointer"
              class="search"
            />
          </el-input>
        </div>
      </div>
      <div class="logoBox_input lt" style="margin-top: 31px">
        <div style="margin-left: 0">
          <img
            src="@/imgs/zh.png"
            alt=""
            class="fa fa-exchange pointer"
            v-if="$i18n.locale == 'en'"
            @click="changeLang('zh-CN')"
          />
          <img
            src="@/imgs/en.png"
            alt=""
            class="fa fa-exchange pointer"
            v-else
            @click="changeLang('en')"
          />

          <img
            class="fa fa-exchange pointer"
            src="../imgs/ling.png"
            alt=""
            ref="notice"
            @click="clickNotice"
          />
          <img
            class="fa fa-exchange pointer"
            src="../imgs/info.png"
            ref="info"
            alt=""
            @click="clickInfo"
          />
          <img
            class="fa fa-exchange pointer"
            src="../imgs/shoucang.png"
            alt=""
            style="margin-right: 0px"
            @click="toCollection"
          />
        </div>
      </div>
      <div class="logoBox_input userName" style="margin-top: 31px">
        <div
          @click="toUser"
          class="pointer"
          style="margin: 0; display: flex; align-items: center"
        >
          <img
            :src="userInfo.head_img"
            alt=""
            style="margin-right: 0px; border-radius: 50%"
            v-if="isLogin"
          />
          <img
            src="@/imgs/touxiang.png"
            alt=""
            style="margin-right: 0px; border-radius: 50%"
            v-else
          />
          <div style="margin-left: 8px" v-if="isLogin">{{ userInfo.user_nickname }}</div>
          <div style="margin-left: 8px" v-else>{{ $t("请先登录") }}</div>
        </div>
        <div
          @click="getenvironment"
          style="margin-right: 0"
          class="release pointer"
          v-if="fbShow"
        >
          <i class="el-icon-plus" style="color: #333333; font-weight: bold"></i>
          <span style="margin-left: 8px">{{ $t("发布") }}</span>
        </div>
      </div>
    </div>
    <div
      class="NavBox"
      v-if="
        navShow &&
        ($route.path == '/home' ||
          $route.path == '/forum' ||
          $route.path == '/trading' ||
          $route.path == '/rentHouse' ||
          $route.path == '/twoHandcart' ||
          $route.path == '/recruitment' ||
          $route.path == '/todayDiscount' ||
          $route.path == '/businessman' ||
          $route.path == '/pet' ||
          $route.path == '/localLife')
      "
    >
      <el-menu
        class="el-menu-demo"
        mode="horizontal"
        text-color="#333333"
        router
        :default-active="$route.path"
        active-text-color="#ffd04b"
      >
        <el-menu-item index="/home" :class="{ 'no-active': $route.query.keyword }">{{
          $t("首页")
        }}</el-menu-item>
        <el-menu-item index="/forum">{{ $t("论坛") }}</el-menu-item>
        <el-menu-item index="/trading">{{ $t("二手交易") }}</el-menu-item>
        <el-menu-item index="/rentHouse">{{ $t("租房") }}</el-menu-item>
        <el-menu-item index="/twoHandcart">{{ $t("二手车") }}</el-menu-item>
        <el-menu-item index="/recruitment">{{ $t("招聘") }}</el-menu-item>
        <el-menu-item index="/todayDiscount">{{ $t("今日折扣") }}</el-menu-item>
        <el-menu-item index="/businessman">{{ $t("入驻商家") }}</el-menu-item>
        <el-menu-item index="/pet">{{ $t("宠物") }}</el-menu-item>
        <el-menu-item index="/localLife">{{ $t("本地生活") }}</el-menu-item>
      </el-menu>
    </div>
    <!-- 私信提醒 -->
    <privateLetter
      :left="infoLeft"
      ref="infoPopup"
      :info="chatUserList"
      @chat="chat"
    ></privateLetter>
    <!-- 通知提醒 -->
    <noticePopup :left="noticeLeft" ref="noticePopup"></noticePopup>

    <div class="chat" v-if="chatshow">
      <chat @closechat="closeChat" :friendInfo="friendInfo"></chat>
    </div>
  </section>
</template>

<script>
import chat from "@/components/chat.vue";
import moment from "moment";
// import Service from "@/api/request.js";
import privateLetter from "@/components/privateLetter.vue";
import noticePopup from "@/components/noticePopup.vue";
import api from "@/api/request1/index.js";
import Service from "@/api/request/index.js";
export default {
  name: "headerTop",
  props: {
    navShow: {
      type: Boolean,
      default: false,
    },
    fbShow: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    privateLetter,
    noticePopup,
    chat,
  },
  data() {
    return {
      activeName: "first",
      dialogVisible: false,
      environmentdialog: false,
      activeIndex: "/monitor",
      transionDialog: false,
      nowday: null,
      Time: null,
      loginOut: false,
      lockdialog: false,
      reserveUser: null,
      treedialog: false,
      errorColor: "#fff",
      allerror: [],
      timer6: null,
      input3: null,
      infoLeft: 0,
      noticeLeft: 0,
      userInfo: JSON.parse(localStorage.getItem("USER_INFO")) || {},
      chatUserList: [],
      chatshow: false,
      friendInfo: {},
      language: localStorage.getItem("lang") || "EN",
    };
  },
  computed: {
    isLogin() {
      let token = localStorage.getItem("USER_TOKEN") || "";
      return token ? true : false;
    },
  },
  created() {
    this.getChatUserList();

    console.log(this.$i18n.locale, "dididiid");
  },
  mounted() {
    // this.getUserInfo();
  },
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
      this.$store.commit("setLanguage", lang);

      location.reload();

      console.log(this.$t("主页"));

      //   console.log(this.$i18n);
      //    if (this.language == "EN"){
      //      localStorage.setItem("locale", "zh");
      //      this.$i18n.locale = localStorage.getItem("locale");
      //      this.$message({
      //        message:"切换为中文！",
      //        type:"success"
      //      });
      //      localStorage.setItem("lang", "ZH");
      //      this.language = "ZH";
      //      location.reload(); //重新加载
      //    } else if (this.language == "ZH"){
      //      localStorage.setItem("locale", "en");
      //      this.$i18n.locale = localStorage.getItem("locale");
      //      this.$message({
      //        message:"Switch to English!",
      //        type:"success"
      //      });
      //      localStorage.setItem("lang", "EN");
      //      this.language = "EN";
      //      location.reload();
      //    }
    },
    chat(e) {
      console.log(e);
      this.friendInfo = e;
      this.chatshow = true;
    },
    closeChat() {
      console.log("pppooo");
      this.chatshow = false;
    },

    customEmoji(value) {
      return `<img src="../../../static/faces/${value}" style="width:20px"/>`;
    },

    renderTxt(txt = "") {
      let rnTxt = [];
      let match = null;
      const regex = /(\[.*?\])/g;
      let start = 0;
      let index = 0;
      while ((match = regex.exec(txt))) {
        index = match.index;
        if (index > start) {
          rnTxt.push(txt.substring(start, index));
        }
        if (match[1] in emoji.obj) {
          const v = emoji.obj[match[1]];
          rnTxt.push(this.customEmoji(v));
        } else {
          rnTxt.push(match[1]);
        }
        start = index + match[1].length;
      }
      rnTxt.push(txt.substring(start, txt.length));
      return rnTxt.toString().replace(/,/g, "");
    },

    getChatUserList() {
      Service.post63687a04ce172({}).then((res) => {
        console.log("ssssdddd", res);
        if (res.code == 1) {
          this.chatUserList = res.data;
        }
      });
    },
    // 获取用户信息
    // getUserInfo() {
    //     if (this.isLogin) {
    //         api.post62bd01fd4eb3d({
    //             user_id: this.userInfo.id || 0
    //         }).then(res => {
    //             console.log('ressssssss', res.data)
    //         })
    //     }
    // },
    handleSearch() {
      if (this.input3 && this.input3.trim() != "") {
        this.$router.push({
          path: "/transition",
          query: {
            keyword: this.input3,
          },
        });
        this.$emit("search", this.input3);
      } else {
        this.$message.info("请输入搜索关键字");
      }
      this.input3 = "";
    },
    toUser() {
      if (this.isLogin) {
        this.$router.push("/user");
      } else {
        this.$router.push("/login");
      }
    },

    treeok() {
      if (this.node != null) {
        this.showLogExport.pathName = this.node.src;
      }
      this.treedialog = false;
    },
    handleNodeClick(data, node) {
      this.node = data;
    },

    renderTree(arr, b) {
      for (var son of arr) {
        if (son.label.startsWith("/")) {
          son.src = son.label;
        } else {
          son.src = b + son.label;
        }
        if (son.children.length > 0) {
          this.renderTree(son.children, son.src + "/");
        }
      }
    },
    getenvironment() {
      if (this.isLogin) {
        this.$router.push("/release");
      } else {
        this.$message.info("请先登录");
        setTimeout(() => {
          this.$router.push("/login");
        }, 800);
      }
      // this.environmentdialog = true;
      // this.getEnvironMonitorInfo();
      // this.getSensorData();
      // this.timer2 = setInterval(()=>{
      //     this.getSensorData();
      // },10000)
    },

    changeInfo() {
      this.infoLeft = this.$refs.info.getBoundingClientRect().left;
    },
    changeNotice() {
      this.noticeLeft = this.$refs.notice.getBoundingClientRect().left;
    },
    clickInfo() {
      this.$refs.infoPopup.show();
      this.changeInfo();
      window.addEventListener("resize", this.changeInfo, true);
    },
    clickNotice() {
      this.$refs.noticePopup.show();
      this.changeNotice();
      window.addEventListener("resize", this.changeNotice, true);
    },
    toCollection() {
      if (this.isLogin) {
        this.$router.push("/collection");
      } else {
        this.$message.info("请先登录");
        setTimeout(() => {
          this.$router.push("/login");
        }, 800);
      }
    },
    // 登录页
    logoClick() {
      this.$router.push({
        url: "/home",
        name: "home",
      });
    },
  },
  destroyed() {
    window.removeEventListener("resize", this.changeInfo);
  },
};
</script>

<style scoped lang="scss">
@import "themePath/header";
@import "themePath/table";

.chat {
  // width: 1920px;
  height: 540px;
  // background: #FF9B57;
  position: fixed;
  left: 180px;
  right: 180px;
  top: 104px;
  z-index: 999999;
  display: flex;
  // justify-content: center;
  // align-items: center;
}
.date-picke {
  /deep/.el-input--prefix .el-input__inner::placeholder {
    color: #fff;
  }
}
/deep/ .el-input__inner::placeholder {
  color: #bfbfbf;
  font-size: 14px;
}
/deep/ .el-input-group--append .el-input__inner {
  height: 40px;
  line-height: 40px;
  border-radius: 6px !important;
}
/deep/ .el-input-group__append {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 30px;
  border-radius: 6px;
}
/deep/ .el-input {
  margin: 0 !important;
  height: 40px;
  line-height: 40px;
  border-radius: 6px;
}
.lockdialog {
  /deep/ .el-form {
    width: 70%;
    margin: 0 auto;
  }
}
/deep/ .textareaInpt {
  .el-form-item__label {
    min-height: 54px;
    line-height: 54px;
  }
  .el-textarea__inner {
    color: #fff;
  }
}
/deep/ .QRcodedialog .el-dialog {
  width: 194px;
  margin-top: 30vh !important;
  .el-dialog__body {
    padding: 0 !important;
    .secretkeybox {
      height: 150px;
    }
  }
}
/deep/ .OperationManualdialog .el-dialog {
  width: 55%;
  margin-left: 0;
  margin-top: 0vh !important;
  .el-dialog__header {
    .el-dialog__headerbtn {
      right: unset !important;
      left: 20px;
    }
    .dialogTitle {
      > i {
        float: left;
        margin-left: 10px;
        font-size: 10px;
        color: #94a3e1;
        margin-top: 17px;

        &:first-child {
          margin-left: 20px;
        }
        cursor: pointer;
      }
    }
  }
  .el-dialog__body {
    width: 100%;
    position: absolute;
    top: 44px;
    bottom: 0;
    .secretkeybox {
      height: 100%;
      background: #cccccc;
      overflow-y: auto;
    }
  }
}
/deep/ .OperationManualdialog2 .el-dialog {
  width: 100% !important;
}
/deep/ .widthdialog .el-dialog {
  width: 1100px !important;
}
img {
  width: 32px;
  height: 32px;
}
.logoBox_input {
  img {
    margin-right: 26px;
  }
  .search {
  }
}
.userName {
  position: absolute;
  right: 0;
  display: flex;
  align-items: center;
}
.release {
  width: 88px;
  height: 40px;
  background: #fee60f;
  border-radius: 6px 6px 6px 6px;
  text-align: center;
  line-height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/headerTop.vue